module.exports = __webpack_public_path__ + "img/madera005.9afc4f25.jpg";